<script setup lang="ts">
import '@/assets/scss/form.scss';
import AccountPicker from '@/onenetwork/components/account_picker/AccountPicker.vue';
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant';
import { numHelper } from '@/utils/numHelper.ts';
import { yupResolver } from '@primevue/forms/resolvers/yup';
import { useConfirm } from 'primevue';
import { useToast } from 'primevue/usetoast';
import { ref, watch } from 'vue';
import TransactionAPI from '../constants/transaction.api.uri.const';
import { initialValuesDeduct, schemaDeduct } from '../helper/validateTransactionSchema';
import CsButton from '@/components/ui/button/CsButton.vue';

const confirm = useConfirm();

interface Props {
  account: object | undefined,
}

const props = defineProps<Props>()

const emit = defineEmits(['update:closeModal'])
const toast = useToast();
const loading = ref(false)
const initialValues = ref(initialValuesDeduct);

watch(() => props.account, (newValue) => {
  initialValues.value.user_id = newValue ? newValue.id : '';
}, { immediate: true });

const resolver = yupResolver(schemaDeduct);

const requestDeduct = async (data: any) => {
  loading.value = true
  try{
    const res = await APIClient.post(TransactionAPI.transactions.deduct, data);

    if (res.data.code === 200) {
      //close modal
      loading.value = false
      toast.add({ severity: 'success', summary: 'Success', detail: 'Trừ tiền thành công', life: 3000 });
      emit('update:closeModal');
      return;
    }
  } catch (e: any) {
    loading.value = false
    const errorMessage = e.response?.data?.message || 'Đã có lỗi xảy ra';
    toast.add({ severity: 'error', summary: 'Error', detail: errorMessage, life: 3000 });
  }
}


const onFormSubmit = ({values, valid}: any) => {
  console.log('values', values, valid)
  if (!valid) {
    return;
  }
  confirm.require({
    message: 'Bạn có muốn thao tác trừ tiền?',
    header: 'Xác nhận',
    // icon: 'pi pi-exclamation-triangle',
    rejectProps: {
      label: 'Huỷ',
      severity: 'secondary',
      outlined: true
    },
    acceptProps: {
      label: 'Đồng ý'
    },
    accept: () => {
      console.log('valuesxx', values)
      requestDeduct(values);
    },
    reject: () => {
      // toast.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
    }
  });
};

</script>

<template>
  <div class="pt-3">
    <Form
      v-slot="$form"
      :initial-values="initialValues"
      :resolver="resolver"
      @submit="onFormSubmit"
      class="flex flex-col w-full"
    >
    <InputText name="user_id" type="hidden" class="form-control" />
      <div class="flex flex-col flex-3">
        <div class="flex mb-3 gap-3" v-if="!props.account">
          <div class="flex-1 text-right">Tài khoản:</div>
          <div class="flex-2">
            <account-picker @update:selected="(e)=>{
              $form.user_id.value = e[0]?.id || '';
            }"/>
            <span class="font-italic text-[12px] text-red-500">
              {{$form?.user_id?.error?.message}}
            </span>
          </div>
        </div>
        <div class="flex mb-3 gap-3">
          <div class="flex-1 text-right">Số tiền:</div>
          <div class="flex-2">
            <InputNumber name="amount" class="form-control" inputId="minmax-buttons" suffix=" đ" mode="decimal" locale="vi-VN" :min="0" :max="1000000000" fluid />
            <span class="font-italic text-[12px] text-red-500">{{numHelper($form?.amount?.value).numberToVietnameseText({unit: 'đồng'})}}</span>
            <span class="font-italic text-[12px] text-red-500">
              {{$form?.amount?.error?.message}}
            </span>
          </div>
        </div>
        <div class="flex mb-3 gap-3">
          <div class="flex-1 text-right">Mã giao dịch:<br/>(Bank Transaction Content)</div>
          <div class="flex-2">
            <InputText name="transaction_code" type="text" class="form-control" />
            <span class="font-italic text-[12px] text-red-500">
              {{$form?.transaction_code?.error?.message}}
            </span>
          </div>
        </div>
        <div class="flex mb-3 gap-3">
          <div class="flex-1 text-right">Nội dung:</div>
          <div class="flex-2">
            <InputText name="content" type="text" class="form-control" />
            <span class="font-italic text-[12px] text-red-500">
              {{$form?.content?.error?.message}}
            </span>
          </div>
        </div>
        <div class="flex mb-3 gap-3" >
          <div class="flex-1 text-right"></div>
          <div class="flex-2">
            <!-- <button
              type="submit"
              :class="['btn btn-cs lg', loading ? 'btn-disabled' : 'primary']"
              :disabled="loading">
              <div :class="[loading ? 'flex items-center gap-2' : '']">
                Trừ tiền thủ công
                <Icon icon="eos-icons:three-dots-loading" width="24" height="24" v-if="loading" />
              </div>
            </button> -->
            <CsButton
              type="submit"
              icon="mdi:check-all"
              :disabled="loading"
              :loading="loading"
              text="Trừ tiền thủ công"
            />
          </div>
        </div>
      </div>

    </Form>
  </div>
</template>
